"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("util");

var address_1 = require("../address");

var formatters_1 = require("../formatters");

var utils_1 = require("../utils");

var identity = function identity() {
  return function (result) {
    return result;
  };
};

var EthRequestPayloads = /*#__PURE__*/function () {
  function EthRequestPayloads(defaultFromAddress) {
    var defaultBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';

    _classCallCheck(this, EthRequestPayloads);

    this.defaultFromAddress = defaultFromAddress;
    this.defaultBlock = defaultBlock;
  }

  _createClass(EthRequestPayloads, [{
    key: "getDefaultBlock",
    value: function getDefaultBlock() {
      return this.defaultBlock;
    }
  }, {
    key: "setDefaultBlock",
    value: function setDefaultBlock(block) {
      this.defaultBlock = block;
    }
  }, {
    key: "getId",
    value: function getId() {
      return {
        method: 'net_version',
        format: utils_1.hexToNumber
      };
    }
  }, {
    key: "getNodeInfo",
    value: function getNodeInfo() {
      return {
        method: 'web3_clientVersion',
        format: identity()
      };
    }
  }, {
    key: "getProtocolVersion",
    value: function getProtocolVersion() {
      return {
        method: 'eth_protocolVersion',
        format: identity()
      };
    }
  }, {
    key: "getCoinbase",
    value: function getCoinbase() {
      return {
        method: 'eth_coinbase',
        format: address_1.Address.fromString
      };
    }
  }, {
    key: "isMining",
    value: function isMining() {
      return {
        method: 'eth_mining',
        format: identity()
      };
    }
  }, {
    key: "getHashrate",
    value: function getHashrate() {
      return {
        method: 'eth_hashrate',
        format: utils_1.hexToNumber
      };
    }
  }, {
    key: "isSyncing",
    value: function isSyncing() {
      return {
        method: 'eth_syncing',
        format: formatters_1.outputSyncingFormatter
      };
    }
  }, {
    key: "getGasPrice",
    value: function getGasPrice() {
      return {
        method: 'eth_gasPrice',
        format: formatters_1.outputBigNumberFormatter
      };
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return {
        method: 'eth_accounts',
        format: function format(result) {
          return result.map(address_1.Address.fromString);
        }
      };
    }
  }, {
    key: "getBlockNumber",
    value: function getBlockNumber() {
      return {
        method: 'eth_blockNumber',
        format: utils_1.hexToNumber
      };
    }
  }, {
    key: "getBalance",
    value: function getBalance(address, block) {
      return {
        method: 'eth_getBalance',
        params: [address.toString().toLowerCase(), formatters_1.inputBlockNumberFormatter(this.resolveBlock(block))],
        format: formatters_1.outputBigNumberFormatter
      };
    }
  }, {
    key: "getStorageAt",
    value: function getStorageAt(address, position, block) {
      return {
        method: 'eth_getStorageAt',
        params: [address.toString().toLowerCase(), utils_1.numberToHex(position), formatters_1.inputBlockNumberFormatter(this.resolveBlock(block))],
        format: identity()
      };
    }
  }, {
    key: "getCode",
    value: function getCode(address, block) {
      return {
        method: 'eth_getCode',
        params: [address.toString().toLowerCase(), formatters_1.inputBlockNumberFormatter(this.resolveBlock(block))],
        format: identity()
      };
    }
  }, {
    key: "getBlock",
    value: function getBlock(block) {
      var returnTransactionObjects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return {
        method: util_1.isString(block) && utils_1.isHexStrict(block) ? 'eth_getBlockByHash' : 'eth_getBlockByNumber',
        params: [formatters_1.inputBlockNumberFormatter(this.resolveBlock(block)), returnTransactionObjects],
        format: formatters_1.fromRawBlockResponse
      };
    }
  }, {
    key: "getUncle",
    value: function getUncle(block, uncleIndex) {
      var returnTransactionObjects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return {
        method: util_1.isString(block) && utils_1.isHexStrict(block) ? 'eth_getUncleByBlockHashAndIndex' : 'eth_getUncleByBlockNumberAndIndex',
        params: [formatters_1.inputBlockNumberFormatter(this.resolveBlock(block)), utils_1.numberToHex(uncleIndex), returnTransactionObjects],
        format: formatters_1.fromRawBlockResponse
      };
    }
  }, {
    key: "getBlockTransactionCount",
    value: function getBlockTransactionCount(block) {
      return {
        method: util_1.isString(block) && utils_1.isHexStrict(block) ? 'eth_getBlockTransactionCountByHash' : 'eth_getBlockTransactionCountByNumber',
        params: [formatters_1.inputBlockNumberFormatter(this.resolveBlock(block))],
        format: utils_1.hexToNumber
      };
    }
  }, {
    key: "getBlockUncleCount",
    value: function getBlockUncleCount(block) {
      return {
        method: util_1.isString(block) && utils_1.isHexStrict(block) ? 'eth_getUncleCountByBlockHash' : 'eth_getUncleCountByBlockNumber',
        params: [formatters_1.inputBlockNumberFormatter(this.resolveBlock(block))],
        format: utils_1.hexToNumber
      };
    }
  }, {
    key: "getTransaction",
    value: function getTransaction(hash) {
      return {
        method: 'eth_getTransactionByHash',
        params: [hash],
        format: formatters_1.fromRawTransactionResponse
      };
    }
  }, {
    key: "getTransactionFromBlock",
    value: function getTransactionFromBlock(block, index) {
      return {
        method: util_1.isString(block) && utils_1.isHexStrict(block) ? 'eth_getTransactionByBlockHashAndIndex' : 'eth_getTransactionByBlockNumberAndIndex',
        params: [formatters_1.inputBlockNumberFormatter(block), utils_1.numberToHex(index)],
        format: formatters_1.fromRawTransactionResponse
      };
    }
  }, {
    key: "getTransactionReceipt",
    value: function getTransactionReceipt(hash) {
      return {
        method: 'eth_getTransactionReceipt',
        params: [hash],
        format: formatters_1.fromRawTransactionReceipt
      };
    }
  }, {
    key: "getTransactionCount",
    value: function getTransactionCount(address, block) {
      return {
        method: 'eth_getTransactionCount',
        params: [address.toString().toLowerCase(), formatters_1.inputBlockNumberFormatter(this.resolveBlock(block))],
        format: utils_1.hexToNumber
      };
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(tx) {
      tx.from = tx.from || this.defaultFromAddress;
      return {
        method: 'eth_signTransaction',
        params: [formatters_1.toRawTransactionRequest(tx)],
        format: identity()
      };
    }
  }, {
    key: "sendSignedTransaction",
    value: function sendSignedTransaction(data) {
      return {
        method: 'eth_sendRawTransaction',
        params: [data],
        format: identity()
      };
    }
  }, {
    key: "sendTransaction",
    value: function sendTransaction(tx) {
      var from = tx.from || this.defaultFromAddress;

      if (!from) {
        throw new Error('No from addres specified.');
      }

      return {
        method: 'eth_sendTransaction',
        params: [formatters_1.toRawTransactionRequest(_objectSpread({}, tx, {
          from: from
        }))],
        format: identity()
      };
    }
  }, {
    key: "sign",
    value: function sign(address, dataToSign) {
      return {
        method: 'eth_sign',
        params: [address.toString().toLowerCase(), formatters_1.inputSignFormatter(dataToSign)],
        format: identity()
      };
    }
  }, {
    key: "signTypedData",
    value: function signTypedData(address, dataToSign) {
      return {
        method: 'eth_signTypedData',
        params: [dataToSign, address.toString().toLowerCase()],
        format: identity()
      };
    }
  }, {
    key: "call",
    value: function call(tx, block) {
      tx.from = tx.from || this.defaultFromAddress;
      return {
        method: 'eth_call',
        params: [formatters_1.toRawCallRequest(tx), formatters_1.inputBlockNumberFormatter(this.resolveBlock(block))],
        format: identity()
      };
    }
  }, {
    key: "estimateGas",
    value: function estimateGas(tx) {
      tx.from = tx.from || this.defaultFromAddress;
      return {
        method: 'eth_estimateGas',
        params: [formatters_1.toRawEstimateRequest(tx)],
        format: utils_1.hexToNumber
      };
    }
  }, {
    key: "submitWork",
    value: function submitWork(nonce, powHash, digest) {
      return {
        method: 'eth_submitWork',
        params: [nonce, powHash, digest],
        format: identity()
      };
    }
  }, {
    key: "getWork",
    value: function getWork() {
      return {
        method: 'eth_getWork',
        format: identity()
      };
    }
  }, {
    key: "getPastLogs",
    value: function getPastLogs(options) {
      return {
        method: 'eth_getLogs',
        params: [formatters_1.toRawLogRequest(options)],
        format: function format(result) {
          return result.map(formatters_1.fromRawLogResponse);
        }
      };
    }
  }, {
    key: "resolveBlock",
    value: function resolveBlock(block) {
      return block === undefined ? this.defaultBlock : block;
    }
  }]);

  return EthRequestPayloads;
}();

exports.EthRequestPayloads = EthRequestPayloads;